import styled from 'styled-components'
import { theme, Row, Box, Input } from '@/client/components'
const { borders, color, font, space, breakpoint } = theme

export const marginSet = `
margin-bottom: 1rem;
`
export const PantoneColorsBlock = styled.div`
  padding: 2rem 0;
  @media (min-width: ${breakpoint.xl}) {
    padding: 1rem 0;
  }
  & .block-p {
    font-size: ${font.size.xsmall};
  }
`
export const GapSec = styled.div`
  margin: 0 0 1rem 0;
`
export const PantoneBlock = styled.div`
  padding: 1rem 0;
`
